const encryption = (value: string): string => {
	const encryptedValue = window.btoa(value as string) as string;

	return encryptedValue;
};

export default encryption;
